import React, { PropsWithChildren, useMemo, useState } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

type CollapsibleRelatedEntitiesCardProps = PropsWithChildren<{
  title: string;
  relationTargetPrefix: string;
}>;

const CollapsibleRelatedEntitiesCard = ({
  title,
  relationTargetPrefix,
  children,
}: CollapsibleRelatedEntitiesCardProps) => {
  const { entity } = useEntity();
  const [expanded, setExpanded] = useState(false);

  const count = useMemo(
    () =>
      (entity.relations ?? []).filter(
        r => r.type === 'hasPart' && r.targetRef.startsWith(relationTargetPrefix),
      ).length,
    [entity, relationTargetPrefix],
  );

  return (
    <Accordion expanded={expanded} onChange={(_, isExpanded) => setExpanded(isExpanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {title} ({count})
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: 'block', padding: 0 }}>
        {expanded && children}
      </AccordionDetails>
    </Accordion>
  );
};

export default CollapsibleRelatedEntitiesCard;
